import SinglePlot from './SinglePlot';

export default SinglePlot;
